import * as React from "react";
const SvgTip = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.795 15.875L4.625 11.705L3.205 13.115L8.795 18.705L20.795 6.705L19.385 5.295L8.795 15.875Z", fill: "white" }));
export default SvgTip;
